import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

function Html({ html }) {
  return <span dangerouslySetInnerHTML={{ __html: html }} />;
}

export default function CookiePolicy() {
  const { t, i18n } = useTranslation();
  const lng = i18n.language.startsWith("it") ? "it" : "en";
  const body = t("legal.cookie.more_body");
  const [moreBefore, moreAfter] = body.split("{{privacyLink}}");
  return (
    <div className="min-h-[100svh] pt-32 pb-20 bg-cream" data-testid="cookie-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-[11px] tracking-[0.3em] uppercase text-slate1 inline-flex items-center gap-2"><Cookie size={12} /> {t("legal.cookie.pre")}</div>
        <h1 className="mt-4 font-display text-4xl lg:text-5xl font-light text-ink">{t("legal.cookie.title")}</h1>
        <p className="mt-3 text-sm text-slate1">{t("legal.cookie.updated")}</p>

        <div className="prose prose-slate max-w-none mt-10 space-y-6 text-ink/90 text-[15px] leading-relaxed">
          <p><Html html={t("legal.cookie.intro")} /></p>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.cookie.categories")}</h2>

            <div className="bg-white border border-ink/10 rounded-sm p-5 mt-4">
              <div className="text-[11px] tracking-[0.2em] uppercase text-gold">{t("legal.cookie.essential")}</div>
              <table className="w-full mt-3 text-sm">
                <thead>
                  <tr className="border-b border-ink/10 text-left">
                    <th className="py-2">{t("legal.cookie.th_name")}</th>
                    <th>{t("legal.cookie.th_purpose")}</th>
                    <th>{t("legal.cookie.th_duration")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-ink/5">
                    <td className="py-2 font-mono text-xs">access_token</td>
                    <td>{t("legal.cookie.row_access_purpose")}</td>
                    <td>{t("legal.cookie.row_access_duration")}</td>
                  </tr>
                  <tr className="border-b border-ink/5">
                    <td className="py-2 font-mono text-xs">refresh_token</td>
                    <td>{t("legal.cookie.row_refresh_purpose")}</td>
                    <td>{t("legal.cookie.row_refresh_duration")}</td>
                  </tr>
                  <tr>
                    <td className="py-2 font-mono text-xs">ah_cookie_consent</td>
                    <td>{t("legal.cookie.row_consent_purpose")}</td>
                    <td>{t("legal.cookie.row_consent_duration")}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.cookie.legal_basis")}</h2>
            <p>{t("legal.cookie.legal_basis_body")}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.cookie.third_party")}</h2>
            <p><Html html={t("legal.cookie.third_party_body")} /></p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.cookie.how_disable")}</h2>
            <p>{t("legal.cookie.how_disable_intro")}</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="underline">Chrome</a></li>
              <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" className="underline">Firefox</a></li>
              <li><a href="https://support.apple.com/it-it/HT201265" target="_blank" rel="noopener noreferrer" className="underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/it-it/microsoft-edge/" target="_blank" rel="noopener noreferrer" className="underline">Edge</a></li>
            </ul>
            <p>{t("legal.cookie.how_disable_outro")}</p>
          </section>

          <section>
            <h2 className="font-display text-2xl text-ink mt-8">{t("legal.cookie.more")}</h2>
            <p>
              {moreBefore}
              <Link to="/privacy" className="underline">{t("footer.privacy")}</Link>
              {moreAfter || ""}
            </p>
          </section>

          {lng === "en" && (
            <p className="text-xs italic text-slate1 pt-6 border-t border-ink/10 mt-10">{t("legal.cookie.note")}</p>
          )}
        </div>

        <div className="mt-12 text-center">
          <Link to="/" className="inline-flex items-center gap-2 bg-ink text-cream px-6 py-3 text-[12px] tracking-[0.2em] uppercase rounded-sm">
            {t("legal.back_home")}
          </Link>
        </div>
      </div>
    </div>
  );
}
